<template lang="pug">
  v-container
    v-row
      v-col
        v-list(v-if="$get(me, `ads.length`)")
          v-list-item(
            v-for="({ id, name }) in $get(me, `ads`)"
            :key="id"
            @click="$createOnClick({ goToAd }, { id })")
            v-list-item-content
              v-list-item-title {{ name }}
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
        v-sheet(
          v-else
          :elevation="1")
          illustration-state(
            title="Vous n'avez aucune annonce"
            body="Diffusez une annonce sous forme de don gratuit ou faites un ko-don pour voir le contenu de cette page"
            :illustration="illustrationEmptyState")
</template>

<script>
import { page } from '@iez/core'
import data from '@iez/lib/data'
import { mdiChevronRight } from '@mdi/js'
import router from '@iez/core/router/'
import IllustrationState from '@iez/components/illustration-state/'
import illustrationEmptyState from '@iez/illustrations/News'

const route = {
  path: `/my-ads`,
  name: `MyAds`
}

export default {
  ...route,

  components: {
    IllustrationState
  },

  setup () {
    page.topBar.set({
      title: `Mes annonces`
    })

    const me = data.me({
      fields: [
        `id`, {
          ads: [
            `id`,
            `name`
          ]
        }
      ]
    })

    const goToAd = ({ id }) => {
      router.push({
        name: `MyAds_id`,
        params: {
          id
        }
      })
    }

    return {
      me,
      mdiChevronRight,
      goToAd,
      illustrationEmptyState
    }
  }
}
</script>
